import type { HTMLAttributes } from "react";
import { cn } from "../lib/utils";

export type ChipTone = "active" | "stalled" | "failing" | "info" | "neutral";
/** `small` sits inline in dense rows of 13px text; `default` matches small controls. */
export type ChipSize = "default" | "small";

export function Chip({
  tone = "neutral",
  size = "default",
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement> & { tone?: ChipTone; size?: ChipSize }) {
  return <span className={cn("sqk-chip", className)} data-size={size} data-tone={tone} {...props} />;
}
